import { useGlobalState } from '@/hooks';
import { PmtOnboardingPopupCta } from '@/interfaces/tracking/trackingOnboardingPopup.interfaces';
import { usePopUpsContext } from '@/modules/pmt/context';
import { useMemo } from 'react';

// popup params belong to the Join Us popup (timed or get-notified); login button, delayed shipment and request-login sign-ups leave them empty
export const isJoinUsPopupCta = (cta?: PmtOnboardingPopupCta) =>
  cta === undefined || cta === PmtOnboardingPopupCta.TimedPopup || cta === PmtOnboardingPopupCta.Noti;

// cta for the login request body and sign events; timed_popup when no button flag is set (the timer opened the popup)
export const useLoginCta = () => {
  const { isFromGetNotifiedBtn, isFromEmailSyncBtn, isFromDelayedShipmentBtn } = useGlobalState();
  const { isFromRequestLoginDialog } = usePopUpsContext();

  return useMemo(() => {
    switch (true) {
      case isFromGetNotifiedBtn:
        return PmtOnboardingPopupCta.Noti;
      case isFromEmailSyncBtn:
        return PmtOnboardingPopupCta.Login;
      case isFromDelayedShipmentBtn:
        return PmtOnboardingPopupCta.DelayedShipment;
      case isFromRequestLoginDialog:
        return PmtOnboardingPopupCta.ShipmentSummary;
      default:
        return PmtOnboardingPopupCta.TimedPopup;
    }
  }, [isFromGetNotifiedBtn, isFromEmailSyncBtn, isFromDelayedShipmentBtn, isFromRequestLoginDialog]);
};
